import React from "react";
import VoltageGauge from "../../components/VoltageGauge";
import CurrentBar from "../../components/CurrentBar";
import CosfiMiniGauge from "../../components/CosfiMiniGauge";


import ReactiveWeeklyActiveEnergyChart from "../../components/ReactiveWeeklyActiveEnergyChart";
import ReactiveWeeklyReactiveEnergyChart from "../../components/ReactiveWeeklyReactiveEnergyChart";
import ReactiveEnergyTrend24h from "../../components/ReactiveEnergyTrend24h";

import AnalyzerRatioGauge from "../../components/AnalyzerRatioGauge";
import { useTranslation } from "react-i18next";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function ReactiveDashboard({ data, deviceId, refreshKey }) {
    const { t } = useTranslation();
    if (!data)
        return <div className="p-6 text-center text-slate-500">{t('hierarchy.loading')}</div>;

    const totalQ =
        (data.reactivePower?.Q1 ?? 0) +
        (data.reactivePower?.Q2 ?? 0) +
        (data.reactivePower?.Q3 ?? 0);

    return (
        <div className="space-y-6">

            {/* ---------------- VOLTAJ / AKIM ---------------- */}
            <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
                <h3 className="text-sm font-semibold text-slate-700 mb-3">{t('dashboard.voltageAndCurrent')}</h3>

                <div className="flex flex-col lg:flex-row gap-8">
                    {/* SOL TARAF – VOLTAJ */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 flex-1">
                        {["VL1", "VL2", "VL3"].map((key) => (
                            <VoltageGauge
                                key={key}
                                label={key}
                                value={data.voltages[key]}
                                vtr={data.ratios?.VTR || 1}
                                isLine={false}
                            />
                        ))}

                        {["VL12", "VL23", "VL31"].map((key) => (
                            <VoltageGauge
                                key={key}
                                label={key}
                                value={data.voltages[key]}
                                vtr={data.ratios?.VTR || 1}
                                isLine={true}
                            />
                        ))}
                    </div>

                    {/* SAĞ TARAF – AKIM */}
                    <div className="flex flex-row items-end justify-center gap-2 sm:gap-4 md:gap-8 min-w-[220px]">
                        <CurrentBar label="I1" value={data.currents.I1} max={100} />
                        <CurrentBar label="I2" value={data.currents.I2} max={100} />
                        <CurrentBar label="I3" value={data.currents.I3} max={100} />
                        <CurrentBar
                            label="IΣ"
                            value={
                                (data.currents.I1 ?? 0) +
                                (data.currents.I2 ?? 0) +
                                (data.currents.I3 ?? 0)
                            }
                            max={300}
                        />
                    </div>
                </div>
            </div>

            {/* ---------------- COSFI ---------------- */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                <CosfiMiniGauge label="Cosφ L1" value={data.cosfi.CosFi1} />
                <CosfiMiniGauge label="Cosφ L2" value={data.cosfi.CosFi2} />
                <CosfiMiniGauge label="Cosφ L3" value={data.cosfi.CosFi3} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <AnalyzerRatioGauge
                    deviceId={deviceId}
                    deviceType="reactive"
                    type="end"
                    title={t('dashboard.totalInductive')}
                />

                <AnalyzerRatioGauge
                    deviceId={deviceId}
                    deviceType="reactive"
                    type="cap"
                    title={t('dashboard.totalCapacitive')}
                />
            </div>

            {/* ---------------- SON 7 GÜN ---------------- */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <ReactiveWeeklyActiveEnergyChart
                    deviceId={deviceId}
                    API_BASE={API_BASE}
                    refreshKey={refreshKey}
                />

                <ReactiveWeeklyReactiveEnergyChart
                    deviceId={deviceId}
                    API_BASE={API_BASE}
                    refreshKey={refreshKey}
                />
            </div>

            {/* ---------------- 24 SAAT TREND ---------------- */}
            <ReactiveEnergyTrend24h
                deviceId={deviceId}
                API_BASE={API_BASE}
            />

        </div>
    );
}
